import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { type BaseEvent, BaseEventRuntype } from './base';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const NoticeDismissedBrowserRunType = BaseEventRuntype.And(
  Record({ noticeKey: String, noticeType: String, version: Literal(1) })
);
const NoticeDismissedServerRunType = NoticeDismissedBrowserRunType.And(CoreEventRuntype).And(
  Record({ sessionId: String })
);

type NoticeDismissedBrowserEvent = Static<typeof NoticeDismissedBrowserRunType>;
type NoticeDismissedServerEvent = Static<typeof NoticeDismissedServerRunType>;

const isNoticeDismissedServerEvent = (obj: BaseEvent): obj is NoticeDismissedServerEvent => {
  return obj.event === ClickstreamEventEnum.NOTICE_DISMISSED;
};

export {
  isNoticeDismissedServerEvent,
  NoticeDismissedBrowserRunType,
  NoticeDismissedServerRunType,
  NoticeDismissedBrowserEvent,
  NoticeDismissedServerEvent,
};
